/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskLanguageSupportType from '@jira/spa-apps__project-settings-service-desk-language-support/src/ExportedDefault.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyProjectSettingsServiceDeskLanguageSupport: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof ProjectSettingsServiceDeskLanguageSupportType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-language-support", jiraSpaEntry: "async-project-settings-service-desk-language-support" */ '@jira/spa-apps__project-settings-service-desk-language-support/src/ExportedDefault.tsx'
		),
	),
);

const AsyncProjectSettingsServiceDeskLanguageSupport = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskLanguageSupport}
		pageId="project-settings-language-support"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskLanguageSupport;
